import { __assign, __rest } from "tslib";
import HeadNext from 'next/head';
import React from 'react';
var Head = function (props) {
    var linkTags = props.links || [];
    var metaTags = props.meta || [];
    /**
     * Why create a second array instead do it in a map?
     * NextJS do not let us use React.Fragment to gather two
     * components (links), ref: https://github.com/vercel/next.js/issues/8384
     */
    var _a = linkTags.reduce(function (acc, linkItem) {
        if (linkItem.preload) {
            acc[0].push(linkItem);
        }
        else {
            acc[1].push(linkItem);
        }
        return acc;
    }, [[], []]), automaticPreloadLinks = _a[0], otherLinks = _a[1];
    return (React.createElement(HeadNext, null,
        props.title && React.createElement("title", null, props.title), automaticPreloadLinks === null || automaticPreloadLinks === void 0 ? void 0 :
        automaticPreloadLinks.map(function (_a) {
            var dataTestId = _a["data-testid"], preload = _a.preload, preloadLink = __rest(_a, ['data-testid', "preload"]);
            return (React.createElement("link", __assign({ rel: "preload" }, preloadLink, { key: "preload-".concat(preloadLink.href), "data-testid": "preload-".concat(dataTestId) })));
        }),
        otherLinks.map(function (_a) {
            var rel = _a.rel, href = _a.href, id = _a.id, preload = _a.preload, props = __rest(_a, ["rel", "href", "id", "preload"]);
            return (React.createElement("link", __assign({ href: href, key: "".concat(rel, "-").concat(href), id: id, rel: rel, "data-testid": props['data-testid'] || '' }, props)));
        }),
        metaTags.map(function (metaProps, i) { return (React.createElement("meta", __assign({}, metaProps, { key: metaProps.name || metaProps.property || i }))); })));
};
export default Head;
//# sourceMappingURL=Head.js.map